import { render, staticRenderFns } from "./pageNumber.vue?vue&type=template&id=4c4959d0&scoped=true&"
import script from "./pageNumber.vue?vue&type=script&lang=js&"
export * from "./pageNumber.vue?vue&type=script&lang=js&"
import style0 from "./pageNumber.vue?vue&type=style&index=0&id=4c4959d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4959d0",
  null
  
)

export default component.exports